export default __webpack_public_path__ + "static/media/HealthTeam.5874073e.svg";